<!-- Spinner -->

<!-- Block -->
<ng-template #block_template let-block="block" let-page="page" let-routeElement="routeElement" let-slugs="slugs">
  @if (block && page && routeElement && slugs) {
    @if (!block.hidden && block.id) {
      <div class="navigation-item pl-3 py-1" [class.navigation-item-selected]="slugs.block === block.route">
        <a 
          [routerLink]="['/' + routeElement.path]"
          (click)="nodeSharedFacade.requestNodesByParentId(block.id); blockSelected.emit(block)"
        >
          {{ page.title }}
        </a>
        @if ((appSharedFacade.canReadNode$(block.id) | async) !== true) {
          <medsurf-restricted-lock containerClass="d-block mt-1" [node]="block"></medsurf-restricted-lock>
        }
      </div>
    }
  }
</ng-template>

<!-- Chapter -->
<ng-template #chapter_template let-chapter="chapter" let-page="page" let-routeElement="routeElement" let-slugs="slugs" let-nodeSettings="nodeSettings">
  @if (chapter && page && routeElement && slugs && !chapter.hidden) {
    @if (quizNavChaptersFiltering(page, nodeSettings?.quizNavSelection || false)) {
      <div 
        class="card-header p-0"
        [class.panel-heading-active]="slugs.chapter === chapter.route"
      >
        <a 
          class="d-block px-3 py-2"
          [routerLink]="['/' + routeElement.path]"
          (click)="nodeSharedFacade.requestNodesByParentId(chapter.id); chapterSelected.emit(chapter)"
        >
          {{ page.title }}
        </a>
        @if ((appSharedFacade.canReadNode$(chapter.id) | async) !== true) {
          <medsurf-restricted-lock containerClass="d-inline-flex px-3 pb-3" [node]="chapter"></medsurf-restricted-lock>
        }
      </div>
    }
    @if (slugs.chapter === chapter.route && !['QuizStart', 'Vocabulary'].includes(page.type)) {
      <div class="card-body pb-2"
        [class.panel-body-active]="slugs.chapter === chapter.route"
        >
        @if ((nodeSharedFacade.nodeByIds$(chapter.children) | async) | sortBy_shared:'asc':'position'; as blocks) {
          @if (appSharedFacade.canReadNode$(chapter.id) | async) {
            @if (chapter.children.length !== 0 && blocks.length === 0) {
              <div class="d-flex justify-content-center m-2">
                <div class="spinner-border"></div>
              </div>
            }
            @for (block of blocks; track block) {
              <ng-container *ngTemplateOutlet="block_template;context:{
                  block: block,
                  page: (appSharedFacade.page$(block.page) | async),
                  routeElement: (appSharedFacade.routeElement$(block.id) | async),
                  slugs: slugs}">
              </ng-container>
            }
          } @else {
            @for (child of chapter.children; track child; let idx = $index;) {
              <div
                class="navigation-item pl-3 py-1 black" 
                style="filter: blur(3px); pointer-events: none; user-select: none;"
              >
                {{ idx + 1 }}. Unterkapitel {{ idx + 1 }}
              </div>
            }
          }
        }
      </div>
    }
  }
</ng-template>

<!-- Content -->
<aside>
  @if ({ 
    settings: (nodeSharedFacade.currentSelectedSettings$ | async), 
    color: (appSharedFacade.themeColor$ | async),
    node: (nodeSharedFacade.currentSelectedSubjectNode$ | async),
    chapters: (nodeSharedFacade.currentSelectedChapterNodes$ | async | sortBy_shared:'asc':'position'),
  }; as subject) {
    @if (subject.node; as subjectNode) {
      <!-- Show current subject in mobile sidebar -->
      <div class="container-navigation" [ngClass]="subject.color + '-hover'">
        @if (showCurrentSubject) {
          <div class="card">
            <div class="card-header">
              <a [routerLink]="['/' + (navigationControlFacade.subjectUrl$ | async)]">
                @if ((appSharedFacade.page$(subjectNode.page) | async); as page) {
                  {{ page.title }}
                }
              </a>
            </div>
          </div>
        }
        @if ((appSharedFacade.canReadNode$(subjectNode.id) | async) !== true) {
          <medsurf-restricted-lock containerClass="p-3 d-inline-flex" [node]="subjectNode"></medsurf-restricted-lock>
        }
        
        @if (appSharedFacade.canReadNode$(subjectNode.id) | async) {
          @if (subjectNode.children.length !== 0 && subject.chapters.length === 0) {
            <div class="d-flex justify-content-center m-2">
              <div class="spinner-border"></div>
            </div>
          } @else {
            <div class="card panel-default"></div>
          }
          @for (chapter of subject.chapters; track chapter) {
            <div class="card panel-default">
              <ng-container *ngTemplateOutlet="chapter_template;context:{
                chapter: chapter,
                page: (appSharedFacade.page$(chapter.page) | async),
                routeElement: (appSharedFacade.routeElement$(chapter.id) | async),
                slugs: (navigationControlFacade.slugs$ | async),
                nodeSettings: subject.settings}">
              </ng-container>
            </div>
          }
        } @else {
          @for (child of subjectNode.children; track child; let idx = $index;) {
            <a 
              class="card-header d-flex flex-wrap justify-content-between align-items-center" 
              style="filter: blur(3px); pointer-events: none; user-select: none;"
            >
              {{ idx + 1 }}. Unterkapitel 
            </a>
          }
        }
      </div>
    }
  }
</aside>
